module.exports = __webpack_public_path__ + "static/media/kitchenNew.d15b798f.png";